module.exports = __webpack_public_path__ + "static/media/icons8_paint_brush.af6d9057.svg";